import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to, from ,savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login']
  const storeManagerPages = ['/pedidos/estado','/pedidos/estado/todos']
  const authRequired = !publicPages.includes(to.path)
  const authStore = !storeManagerPages.includes(to.path)
  const editOrderStore = !to.path.includes('/pedidos/estado/edit')
  const loggedIn = localStorage.getItem('token')
  const role = localStorage.getItem('role')

  if (authRequired && (!loggedIn || role=='User')) {
    return next('/login')
  }

  if ((editOrderStore && authStore) && role=='Store'){
    return next('/pedidos/estado')
  }

  if (role=='User') {
    return next('/login')
  }

  next()
})

export default router;
